// import * as PIXI from "pixi.js";
import BlanketGenerator from "../generators/BlanketGenerator";
import { convertSize } from "../utils";

export function loadBlanket({ renderer, parent, texture }) {
  const { width, height } = renderer.screen;
  const layout = {
    width: convertSize(122, window.innerWidth),
    height: convertSize(87.5, window.innerWidth)
  };

  let y = height - layout.height;
  if (height >= 720) { 
    // iPhone X
    y = y - convertSize(50, window.innerWidth);
  }

  const blanket = BlanketGenerator({
    ...layout,
    zIndex: 1,
    x: width / 2 - layout.width / 2,
    y,
    innerWidth: window.innerWidth,
    texture
  });

  // const container = new PIXI.container();
  // const entranceZone = new PIXI.Rectangle()

  // container.addChild(blanket)
  // stage.addChild(container);

  // Hit zone
  // 130, 80
  // 260 70
  //  130 35
  // const entrance = new PIXI.DisplayObject();
  // entrance.hitArea = new PIXI.Rectangle(convertSize(18), convertSize(35), convertSize(75), convertSize(1));

  // blanket.addChild(entrance)

  parent.addChild(blanket);

  return blanket;
}
